import React from "react";
import { ThemeProvider } from "styled-components/native";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import theme from "../../configs/theme-config";

import HomeNewScreen from "../../pages/HomeNew-page";
import ServicesScreen from "../../pages/Services-page";
import ProfileScreen from "../../pages/Profile-page";
import OrdersListScreen from "../../pages/UserOrdersList-page";
import AddressesListScreen from "../../pages/UserAddressesList-page";
import TransactionsListScreen from "../../pages/UserTransactionsList-page";
import PersonalizationScreen from "../../pages/Personalization-page";
import BasketScreen from "../../pages/Basket-page";
import NewAddressScreen from "../../pages/NewAddress-page";
import AppInfoScreen from "../../pages/AppInfo-page";
import EditProfileScreen from "../../pages/EditUserProfileInfo-page";
import OrderView from "../../pages/OrderView-page";
import withRedux from "../withRedux";
import LoginModal from "../LoginModal";
import IOSInstallationBanner from "../IOSInstallationBanner";
import { LoginContext } from "../../contexts/login";
import useLogin from "../../hooks/useLogin";
import { ToastProvider } from "digiwash-components";
import AuthenticatedRoute from "../AuthenticatedRoute/AuthenticatedRoute-component";

function App() {
  let [isLoginModalOpen, setLoginModalOpen] = React.useState(false);
  let login = useLogin();

  return (
    <ThemeProvider theme={theme}>
      <ToastProvider>
        <LoginContext.Provider
          value={{
            isLoginModalOpen,
            setLoginModalOpen,
          }}
        >
          <Router>
            <Switch>
              <AuthenticatedRoute path="/orders/:order_id">
                <OrderView />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/orders">
                <OrdersListScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/profile/edit">
                <EditProfileScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/profile/info">
                <AppInfoScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/profile/transactions">
                <TransactionsListScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/profile/personalization">
                <PersonalizationScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/profile/addresses/add">
                <NewAddressScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/profile/addresses">
                <AddressesListScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/profile">
                <ProfileScreen />
              </AuthenticatedRoute>
              <AuthenticatedRoute path="/basket">
                <BasketScreen />
              </AuthenticatedRoute>
              <Route path="/services">
                <ServicesScreen />
              </Route>
              <Route path="/">
                <HomeNewScreen />
              </Route>
            </Switch>
          </Router>
          <IOSInstallationBanner />

          <LoginModal {...login} />
        </LoginContext.Provider>
      </ToastProvider>
    </ThemeProvider>
  );
}
export default withRedux(App);
